var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('z-shorten-text',{attrs:{"text":_vm.text,"short-text":_vm.shortText,"copy":"","show-copy-on-hover":"","tooltip-placement":_vm.tooltipPlacement,"dots":false}})}
var staticRenderFns = []

export { render, staticRenderFns }